import { useState } from "react";

/**
 * Claw 实验机接入密码弹窗相关状态 Hook
 */
const useClawPasswordState = () => {
  const [clawPasswordDialogOpen, setClawPasswordDialogOpen] = useState(false);
  const [clawPasswordInput, setClawPasswordInput] = useState("");
  const [clawPasswordError, setClawPasswordError] = useState("");
  const [clawPasswordLoading, setClawPasswordLoading] = useState(false);

  const resetClawPasswordState = () => {
    setClawPasswordDialogOpen(false);
    setClawPasswordInput("");
    setClawPasswordError("");
    setClawPasswordLoading(false);
  };

  return {
    clawPasswordDialogOpen,
    setClawPasswordDialogOpen,
    clawPasswordInput,
    setClawPasswordInput,
    clawPasswordError,
    setClawPasswordError,
    clawPasswordLoading,
    setClawPasswordLoading,
    resetClawPasswordState,
  };
};

export default useClawPasswordState;
